export const PAGE_SIZE = 25;

export enum BulkPaymentModel {
  BulkACHTransfer = "BulkACHTransfer",
}

// TODO: add translations for web/mobile
export const DisplayStatus = {
  pending_approval: "Pending approval",
  scheduled: "Scheduled",
  in_progress: "In progress",
  completed: "Completed",
  failed: "Failed",
  canceled: "Canceled",
  unknown: "Pending",
  partially_completed: "Completed with issues",
  bulk_payment_canceled: "Canceled",
  awaiting_approval: "Pending approval",
};

export const EMPTY_FILTER_QUERY = {
  state_in: [],
  institution_account_in: [],
  amount_gte: undefined,
  amount_lte: undefined,
  scheduled_date_before: undefined,
  scheduled_date_after: undefined,
  calendar_key: undefined,
  parent: undefined,
  bulk_payment: undefined,
  frequency: [],
  selected_template_ids: [],
  selected_template_version_ids: [],
};
